import { useOperators } from '../../hooks/useAdminQueries';
import './OperatorSelector.css';

interface OperatorSelectorProps {
  selectedOperatorId: string | null;
  onSelect: (operatorId: string) => void;
}

export function OperatorSelector({
  selectedOperatorId,
  onSelect,
}: OperatorSelectorProps) {
  const { data, isLoading, error } = useOperators();

  if (isLoading) {
    return (
      <div className="operator-selector">
        <div className="operator-selector-skeleton">
          <div className="skeleton skeleton-select"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="operator-selector">
        <div className="operator-selector-error">
          <p>Failed to load operators</p>
          <button
            onClick={() => window.location.reload()}
            className="retry-button"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  const operators = data?.operators || [];

  return (
    <div className="operator-selector">
      <label htmlFor="operator-select" className="operator-selector-label">
        Select Operator
      </label>
      <select
        id="operator-select"
        className="operator-selector-dropdown"
        value={selectedOperatorId || ''}
        onChange={(e) => onSelect(e.target.value)}
      >
        <option value="" disabled>
          Choose an operator...
        </option>
        {operators.map((operator) => (
          <option key={operator.id} value={operator.id}>
            {operator.name || operator.id} ({operator.pollingCount} polling items)
          </option>
        ))}
      </select>
      {selectedOperatorId && (
        <div className="operator-selector-info">
          {(() => {
            const selected = operators.find((op) => op.id === selectedOperatorId);
            if (!selected) return null;
            return (
              <div className="operator-info-badges">
                <span className="info-badge">
                  {selected.pollingCount} Polling Items
                </span>
                <span className="info-badge">
                  {selected.configsCount} Configs
                </span>
                {selected.lastSyncAt && (
                  <span className="info-badge">
                    Last sync: {new Date(selected.lastSyncAt).toLocaleString()}
                  </span>
                )}
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
}

